module.exports = __webpack_public_path__ + "static/img/民生银行.5b89bbf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/民生银行.jpg
// module id = M+z1
// module chunks = 1